import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import { useShowMenu } from "../context/ShowMenuContext";
import { useSubHeadingContext } from "../context/SubHeadingContext";

const Menu = () => {
  const { setShowMenu } = useShowMenu();
  const location = useLocation();
  const pathname = location.pathname;

  const isActive = (path: string) => pathname === path;
  const isOneOf = (paths: string[]) => paths.includes(pathname);

  const [isFixed, setIsFixed] = useState(false);
  const { subHeadingData } = useSubHeadingContext();

  const surgicalPaths =
    subHeadingData?.map((item) => {
      const name = item?.attributes?.Sub_Heading_Name;
      const slug = name
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/[^\w\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
      return `/${slug}`;
    }) || [];

  const isSurgicalActive = surgicalPaths.includes(pathname);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 118) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };

  return (
    <nav
      className={`main-menu main-menu-two clearfix ${
        isFixed ? "custom-fixed-menu" : ""
      }`}
    >
      <div className="main-menu-two-wrapper clearfix">
        <div className="container clearfix">
          <div className="main-menu-two-wrapper-inner clearfix">
            <div className="main-menu-two-wrapper__main-menu">
              <Link
                to="#"
                className="mobile-nav__toggler"
                onClick={(e) => {
                  e.preventDefault();
                  setShowMenu(true);
                }}
              >
                <i className="fa fa-bars"></i>
              </Link>
              <ul className="main-menu__list">
                <li className="dropdown megamenu">
                  <Link
                    to="/"
                    onClick={() => linkClicker("")}
                    className={isActive("/") ? "active-menu" : ""}
                  >
                    Home
                  </Link>
                </li>
                <li className="dropdown megamenu">
                  <Link
                    to="/about"
                    onClick={() => linkClicker("about")}
                    className={isActive("/about") ? "active-menu" : ""}
                  >
                    About
                  </Link>
                </li>
                <li className="dropdown">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className={
                      isOneOf(["/founders", "/council-members"])
                        ? "active-menu"
                        : ""
                    }
                  >
                    The Council
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to="/founders"
                        onClick={() => linkClicker("founders")}
                        className={
                          isActive("/founders") ? "active-submenu" : ""
                        }
                      >
                        Founders
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/council-members"
                        className={
                          isActive("/council-members") ? "active-submenu" : ""
                        }
                      >
                        Council Members
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className={
                      isOneOf(["/events", "/newsletters"]) ? "active-menu" : ""
                    }
                  >
                    News & Events
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to="/newsletters"
                        onClick={() => linkClicker("newsletters")}
                        className={
                          isActive("/newsletters") ? "active-submenu" : ""
                        }
                      >
                        Newsletters
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/events"
                        onClick={() => linkClicker("events")}
                        className={isActive("/events") ? "active-submenu" : ""}
                      >
                        Events
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className={
                      isOneOf(["/benefits-of-a-member", "/become-a-member"])
                        ? "active-menu"
                        : ""
                    }
                  >
                    Members Area
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to="/benefits-of-a-member"
                        onClick={() => linkClicker("benefits-of-a-member")}
                        className={
                          isActive("/benefits-of-a-member")
                            ? "active-submenu"
                            : ""
                        }
                      >
                        Benefits of a Member
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/become-a-member"
                        onClick={() => linkClicker("become-a-member")}
                        className={
                          isActive("/become-a-member") ? "active-submenu" : ""
                        }
                      >
                        Become a Member
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to="/list-of-all-member"
                        onClick={() => linkClicker("list-of-all-member")}
                      >
                        List of All Members
                      </Link>
                    </li> */}
                  </ul>
                </li>
                {/* .main-menu .main-menu__list > li + li */}
                <li className="dropdown">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className={
                      isOneOf(["/fellowship", "/observership"])
                        ? "active-menu"
                        : ""
                    }
                  >
                    Our Training
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to="/fellowship"
                        onClick={() => linkClicker("fellowship")}
                        className={
                          isActive("/fellowship") ? "active-submenu" : ""
                        }
                      >
                        Fellowship
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/observership"
                        onClick={() => linkClicker("observership")}
                        className={
                          isActive("/observership") ? "active-submenu" : ""
                        }
                      >
                        Observership
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className={`${isSurgicalActive ? 'active-menu' : ''}`}
                  >
                    Surgical Domains
                  </Link>
                  <ul className="custom-menu-height">
                    {subHeadingData?.map((item, index) => {
                      const name = item?.attributes?.Sub_Heading_Name;
                      const slug = name
                        .toLowerCase()
                        .replace(/&/g, "and")
                        .replace(/[^\w\s-]/g, "")
                        .trim()
                        .replace(/\s+/g, "-");
                      return (
                        <li key={index}>
                          <Link
                            to={`/${slug}`}
                            onClick={() => linkClicker(slug)}
                            className={
                              isActive(`/${slug}`) ? "active-submenu" : ""
                            }
                            style={{ lineHeight: "18px" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span>{name}</span>
                              <span style={{ fontSize: "10px" }}>
                                {item.attributes.Doctor_Name}
                              </span>
                            </div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </li>
                {/* <li className="dropdown">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    Surgical Domains
                  </Link>
                  <ul>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Overview
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/types-of-facial-plastic-surgery"
                            onClick={() =>
                              linkClicker("types-of-facial-plastic-surgery")
                            }
                          >
                            Types of Facial Plastic Surgery
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/who-is-a-facial-plastic-surgeon"
                            onClick={() =>
                              linkClicker("who-is-a-facial-plastic-surgeon")
                            }
                          >
                            Who is a Facial Plastic Surgeon
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Nose
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/rhinoplasty"
                            onClick={() => linkClicker("rhinoplasty")}
                          >
                            Rhinoplasty
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Eyelids
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/lower-blepharoplasty"
                            onClick={() => linkClicker("lower-blepharoplasty")}
                          >
                            Lower Blepharoplasty
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/upper-blepharoplasty"
                            onClick={() => linkClicker("upper-blepharoplasty")}
                          >
                            Upper Blepharoplasty
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Lifts
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/face-lift"
                            onClick={() => linkClicker("face-lift")}
                          >
                            Face Lift
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/fore-head-lift"
                            onClick={() => linkClicker("fore-head-lift")}
                          >
                            ForeHead Lift
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Chin & Ears
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/mentoplasty"
                            onClick={() => linkClicker("mentoplasty")}
                          >
                            Mentoplasty
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/otoplasty"
                            onClick={() => linkClicker("otoplasty")}
                          >
                            Otoplasty
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Skin
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/scar-revision"
                            onClick={() => linkClicker("scar-revision")}
                          >
                            Scar Revision
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/skin-cancer"
                            onClick={() => linkClicker("skin-cancer")}
                          >
                            Skin Cancer
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/skin-peels"
                            onClick={() => linkClicker("skin-peels")}
                          >
                            Skin Peels
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Injectables
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/botulinum-toxin"
                            onClick={() => linkClicker("botulinum-toxin")}
                          >
                            Botulinum Toxin
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        Lipoplasty
                      </Link>
                      <ul>
                        <li>
                          <Link
                            to="/fat-grafting"
                            onClick={() => linkClicker("fat-grafting")}
                          >
                            Fat Grafting
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li> */}
                {/* <li className="dropdown">
                  <Link to="#">Academics</Link>
                  <ul>
                    <li>
                      <Link to="/fellowship" onClick={() => linkClicker("fellowship")}>
                        Fellowship
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/observership"
                        onClick={() => linkClicker("observership")}
                      >
                        Observership
                      </Link>
                    </li>
                  </ul>
                </li> */}
                <li>
                  <Link
                    to="/gallery"
                    onClick={() => linkClicker("gallery")}
                    className={isActive("/gallery") ? "active-menu" : ""}
                  >
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link
                    to="/archive"
                    onClick={() => linkClicker("archive")}
                    className={isActive("/archive") ? "active-menu" : ""}
                  >
                    Archive
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    onClick={() => linkClicker("contact")}
                    className={isActive("/contact") ? "active-menu" : ""}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div className="main-menu-two-wrapper__right">
              <div className="main-menu-two__top-social">
                 <Link to="#">
                  <i className="fab fa-twitter"></i>
                </Link>
                 <Link to="#">
                  <i className="fab fa-facebook"></i>
                </Link>
                 <Link to="#">
                  <i className="fab fa-pinterest-p"></i>
                </Link>
                 <Link to="#">
                  <i className="fab fa-instagram"></i>
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
